import { ScrollArea } from "@/components/ui/scroll-area";
import { Message } from "@/types/chat";
import { ChatMessageList } from "./ChatMessageList";
import { cn } from "@/lib/utils";

interface ChatContainerProps {
  messages: Message[];
  isLoading?: boolean;
}

export function ChatContainer({ messages, isLoading }: ChatContainerProps) {
  return (
    <ScrollArea className="h-full w-full pb-4">
      <div className="flex flex-col gap-2 max-w-4xl mx-auto px-2 md:px-4">
        <ChatMessageList messages={messages} isLoading={isLoading} />
      </div>
    </ScrollArea>
  );
}